// Imports
  // React
  import { useEffect, useState } from 'react'
  import { useParams, Link } from 'react-router-dom'
  // Firebase
  import "../firebase/FirebaseClient"
  import { getOrdersById } from '../firebase/FirebaseClient'
  // Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons"




// rafce

const Order = () => {


  const {id} = useParams()
  const [buyer, setBuyer] = useState([])
  const [cart, setCart] = useState([])
  const [total, setTotal] = useState("")
  const [fecha, setFecha] = useState([])
        
  // Get order from Firestore
  useEffect( () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    getOrdersById(id).then( data => {
    setBuyer(data.buyer)
    setCart(data.cart)
    setTotal(data.total)
    setFecha(data.date)
    })
  }, [])
  

    // Get date
    const formatedDate = () => {
      let timestamp = fecha
      let newDate = new Date(timestamp * 1000)
      //Day
      const dayNames = ["Jueves", "Viernes", "Sábado", "Domingo", "Lunes", "Martes", "Miércoles"]
      let day = dayNames[newDate.getDay()]
      let date = newDate.getDate()+1
      //Month
      const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
      let month = monthNames[newDate.getMonth()]
      //Year
      let year = newDate.getYear()-69
      //Time
      function addZero(i) {
        if (i < 10) {i = "0" + i}
        return i;
      }
      let h = addZero(newDate.getHours());
      let m = addZero(newDate.getMinutes());
      let time = h + ":" + m;
      //RETURN
      return `${day} ${date<10?`0${date}`:`${date}`}/${month}/${year} (${time}hs)`
    }


    //Get Quantity
      const quantity = () => {
				let total=0;
				for(var i=0; i<cart.length; i++) {
					let mappingItems = cart[i];
					total += parseFloat(mappingItems.qty);
				}
				return total;
			}



  // Component
  return (
    <div className='main-admin'>
      <div className='main-admin-buttons'>
        <Link to="/admin/ordenes" style={{alignSelf:"flex-start"}}>
          <FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" />
        </Link>
      </div>
      <div className='main-admin-order'>
        <div className='main-admin-order-date'>{formatedDate()}</div>
        <div className='main-admin-order-buyer'>
          <p>Cliente: <strong>{buyer.name}</strong></p>
          <p>Contacto: <strong>{buyer.phone}</strong></p>
        </div>
        <div className='main-admin-order-items'>
          {
            cart.map( i =>
              <div key={i.id}>
                <span>Cód. {i.code}</span>
                <p>{i.name}</p>
                  <span>{i.qty}</span>
                  <span>${i.price.toFixed(2)} c/u</span>
                </div>
            )
          }
          <strong>Artículos en total= {quantity()}</strong>
        </div>
        <div className="main-admin-order-payment">
          <span>Total $ {total}</span>
          <p>Abonará con: {buyer.payment}</p> 
        </div>
      </div>
    </div>
  )
}

export default Order

